import axios from 'axios';
import {req, reqJson} from './axiosFun';

/**
 * 客房管理
 **/
// 客房管理-获取用户列表
export const roomList = (params) => { return reqJson("post", "/api/business/room/list?pageNum="+params.pageNum+"&pageSize="+params.pageSize, params) };
// 客房管理-保存（添加）
export const roomSave = (params) => { return reqJson("post", "/api/business/room/add", params) };
// 客房管理-保存（编辑）
export const roomEdit = (params) => { return reqJson("put", "/api/business/room/edit", params) };
// 客房管理-（编辑）-客房状态
export const roomStatusEdit = (params) => { return reqJson("put", "/api/business/room/editRoomStatus", params) };
// 客房管理-删除用户
export const roomDelete = (params) => { return req("delete","/api/business/room/deleteById",params)};





// WEBPACK FOOTER //
// ./src/api/roomMg.js